/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import echart from 'echarts'
import './assets/js/gt'
import { baseUrl, url_LN, url_CM, url_LN_local, socket_url_ln, url_temp, URL_KJ } from './api/config';
import './assets/font-awesome/css/font-awesome.min.css'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import VueWechatTitle from 'vue-wechat-title'

Vue.config.productionTip = false

Vue.use(ElementUi);
Vue.use(VueCookies);
Vue.use(VueWechatTitle);

Vue.prototype.$echarts = echart;
Vue.prototype.$baseUrl = baseUrl;
Vue.prototype.$url_LN = url_LN;
Vue.prototype.$url_CM = url_CM;
Vue.prototype.$url_LN_local = url_LN_local;
Vue.prototype.$socket_url_ln = socket_url_ln;
Vue.prototype.$url_temp = url_temp;
Vue.prototype.$URL_KJ = URL_KJ;

Vue.directive('btnpermission', {
  inserted: function(el, binding, vnode) {
    if(store.state.userPermission.strategy.indexOf(binding.value) === -1) {
      el.parentNode.removeChild(el)
    }
  }
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Array.prototype.min = function (array) {
  return Math.min.apply(null, array);
};

Array.prototype.remove = function (num) {
  let index = this.indexOf(num);
  if (index !== -1) {
    this.splice(index, 1);
  }
}



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
